import { render, staticRenderFns } from "./SaleEdit.vue?vue&type=template&id=1580ab4e&scoped=true"
import script from "./SaleEdit.vue?vue&type=script&lang=ts"
export * from "./SaleEdit.vue?vue&type=script&lang=ts"
import style0 from "./SaleEdit.vue?vue&type=style&index=0&id=1580ab4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580ab4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1580ab4e')) {
      api.createRecord('1580ab4e', component.options)
    } else {
      api.reload('1580ab4e', component.options)
    }
    module.hot.accept("./SaleEdit.vue?vue&type=template&id=1580ab4e&scoped=true", function () {
      api.rerender('1580ab4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/SaleEdit.vue"
export default component.exports